import { io } from 'socket.io-client';
import { SERVER_URL } from 'src/utils/config';

export const subscribeTracker = (
  lockId: string,
  handleSocketData: any 
) => {
  const avlSocket = io(`${SERVER_URL}avl_data`);  

  
  avlSocket.once('connect', () => {
    if (avlSocket.connected) { 
    } else {
    }
    
    avlSocket.emit('user_connected', lockId, (err: any) => {
      if (err) {
        alert(err);
      }
    });

    avlSocket.on('data_received', handleDataReceived);
  });

  const handleDataReceived = (msg: any) => {
    const data = JSON.parse(msg);
    handleSocketData(data);
  };

  avlSocket.on('connect_error', (error) => {
  });
  
  avlSocket.on('connect_timeout', (timeout) => {
  });

  avlSocket.on('disconnect', () => {
  });

  return () => {
    avlSocket.off('data_received', handleDataReceived);
    avlSocket.disconnect();
  };
};
